import { useState, KeyboardEvent } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Container } from "react-bootstrap";
// @ts-ignore
import search from "../assets/images/search.svg";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [packageId, setPackageId] = useState("");

  const handleKeyDown = async (event: KeyboardEvent<HTMLInputElement>) => {
    const splitPath = pathname.split("/")[1];
    if (event.key === "Enter") {
      if (splitPath === "p") {
        navigate("/p/" + packageId);
      } else {
        navigate("/cs/" + packageId);
      }
    }
  };

  return (
    <Container>
      <Row className="not_found_container">
        <Col className="not_found_content">
          <Row>
            <Col xxs={1} sm={1} md={1} lg={2} />
            <Col xxs={11} sm={11} md={11} lg={10}>
              <h1 className="not-found-404">{t("notFound.heading")}</h1>
            </Col>
          </Row>
          <Row>
            <Col xxs={4} sm={4} md={3} lg={3} align="right">
              <img
                src={search}
                alt="page_not_found_warning"
                className="not-found-logo"
              />
            </Col>
            <Col xxs={7} sm={7} md={8} lg={8} align="left">
              <p className="not-found-heading">{t("notFound.messageOne")} </p>
              <p className="not-found-text">{t("notFound.messageTwo")}</p>
            </Col>
            <Col xxs={1} sm={1} md={1} lg={1} />
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <input
            id="note"
            type="text"
            className="package-id-input"
            placeholder={
              t("notFound.input_placeholder") || "Enter your package id"
            }
            value={packageId}
            onChange={(event) => setPackageId(event.target.value)}
            onKeyDown={(event) => handleKeyDown(event)}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
